export function enumToOptions<T>(e: T, labelFn?: (label: string) => string) {
  const options: { value: string, label: string }[] = []

  for (let item in e) {
    if (isNaN(Number(item))) {

        const label = labelFn ? labelFn(item) : item
        options.push({ value: item, label });
    }
  }

  return options
}